import { useEffect, useState, useRef, useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import "./DoctorWebsite.css";
import { LanguageContext } from "./LanguageContext";

export default function Görüş() {
  const { lang, toggleLanguage } = useContext(LanguageContext);

  const opinions = [
    "'Değerli hocamızla tanışalı 7 sene oldu.Akademi bilgisi tartışılmaz ve insani değeri yüksek sevgili Emre hocam iyi ki çocuklarımı hep size emanet etmişiz.Oğlumun bir tane Emre hocası....siz iyi ki varsınız.'",
    "'Yeğenim doğduğunda tanıştık Emre hocayla, bir teyze olarak beni bile etkiledi ve benimde bebeğim doğduğunda evime uzak olmasına rağmen bizde Emre hocaya gitmeye karar verdik. Çok kibar ve aydınlatıcı bir doktor, mesleğini hakkıyla yapan çocukları çok seven biri. Tereddütsüz tavsiyemizdir.'",
    "'Emre bey harika bir doktor ve çok iyi bir insan. Çok vaka görmüş deneyimli bir hekim. Doğumundan beri kızımla ilgileniyor. Yaşadığımız ameliyat sürecinde de her zaman bilgisi, sakinliği ile yanımızdaydı. Normal bir muaenede durumu erkenden fark edip doğru kanallara bizi yönlendirmesi destek olması sayesinde süreci rahatça atlattık. Kendisine minnettarız.'",
    "'Emre Bey, oğlumuzun doğduğu ilk andan itibaren yanında oldu ve olmaya devam ediyor. İnanılmaz ilgisi, sevgisi, sakinliği, yetkinliği ile bize her zaman güven verdi. Her sorumuzda ve sorunumuzda her an ulaşabiliyoruz. Bizim 7 yıldır Emre Amca’mız ve ailemizden biri. Gözümüz kapalı olarak en değerli varlığımızı kendisine emanet ediyoruz.'",
    "'Emre Bey ile oğlum 6 aylıkken tanıştık. Emre Bey çocuğu kendi durumuna göre değerlendirir.Kibar ve sakindir.Tüm aşıları kendisi yapmasına rağmen oğlum hiçbir zaman kendisinden korkmadı, sarılarak ayrıldı. Zamanında tespitleri sayesinde kronikleşen hiçbir hastalığımız olmadı. Vitamin takviyelerinde de kendisinden çok yardım aldık. Oğlum 4.5 yaşında ve yakında doğacak bebeğimizin de doktoru olacak,biz kendisinden çok çok memnunuz.'",
    "'Çocukken iyi bir ilkokul öğretmenine denk gelmek ne kadar büyük bir şanssa bebeğinizi Emre Bey’e götürmek de o kadar iyi! Bebeğim doğduğu günden beri hep kendisine gittik. Oldukça ilgili, sakin, dikkatli, çocuğa karşı çok sevecen dünya tatlısı bir doktor.Çevremde bebeği olan herkese önerdiğim, gidenlerin de asla pişman olmadığı biridir.İşini iyi yapan insanlar hangi meslekte olursa olsun dikkat çekiyor. Emre Bey’de öyle işte'",
    "'Hastaneye gidemesek dahi sorularımıza usanmadan yanıt verip destek olan oğlumun kıymetli Doktor Amcası iyi ki sizi tanıdık.'",
    "'Bir dönem beraber çalıştığım, hem insan olarak hem hekim olarak çook çok sevdiğim muhteşem bir insandır. Oldukça fedakar, yeni gelişmeleri takip eden, ilgili, güler yüzlü ve deneyimli bir doktor. Onunla çalıştığım için çok şanslıyım ve gelecekteki çocuklarım da doktoru Emre Amcaları olacağı için çok şanslılar. Yolun aydınlık, şansın hep açık olsun, ayağına taş değmesin doktorum :)'",
    "'Oğlum 7 yaşında, şu ana kadar tanıdığım en iyi çocuk doktorudur. İlgili,alakalı,sevecen ve çok bilgilidir.'",
    "'Kızımın 6 aylıktan beri sevgi dolu doktoru. Simdi 5 yaşına geldi. Seyahatte, gece, gündüz her zaman ulaşılabilir olması ailemiz için cok kıymetli. Cok seviyoruz doktorumuzu.'",
    "'Çok ilgili bilgili ve kibar bir bey kendisi biz bebeğimizi kendisine götürüyoruz ve çok memnunuz'",
  ];
  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const [setSlideW] = useState(340);

  const updateSlideWidth = useCallback(() => {
    if (!sliderRef.current) return;
    const card = sliderRef.current.querySelector(".opinion-box");
    const style = getComputedStyle(sliderRef.current);
    const gap = parseFloat(style.gap) || 0;
    const cardW = card ? card.getBoundingClientRect().width : 320;
    setSlideW(cardW + gap);
  }, []);

  useEffect(() => {
    updateSlideWidth();
    const ro = new ResizeObserver(updateSlideWidth);
    if (sliderRef.current) ro.observe(sliderRef.current);
    window.addEventListener("resize", updateSlideWidth);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", updateSlideWidth);
    };
  }, [updateSlideWidth]);
  const startSlider = useCallback(() => {
    // Avoid multiple intervals stacking up
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % opinions.length);
    }, 3000);
  }, [opinions.length]);

  const stopSlider = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    startSlider();
    return () => stopSlider();
  }, [startSlider, stopSlider]);
  const content = {
    tr: {
      appointment: "Randevu Al",
      aboutme: "Hakkımda",
      media: "Medya",
      opinion: "Görüşler",
      faq: "İletişim",
      socials: "Bana Ulaş",
    },
    en: {
      appointment: "Make an Appointment",
      aboutme: "About Me",
      media: "Media",
      opinion: "Opinions",
      faq: "Contact",
      socials: "Contact Me",
    },
  };
  return (
    <>
      <header className="main-header">
        <div className="header-left">
          <Link to="/">
            <img src="/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        <div className="header-center">
          <nav className="nav-links">
            <a href="/#about">{content[lang].aboutme}</a>
            <a href="/medya" className="text-blue-600 hover:underline">
              {content[lang].media}
            </a>
            <a href="/reviews">{content[lang].opinion}</a>
            <a href="/contact">{content[lang].faq}</a>
          </nav>
          <div className="underline" />
        </div>

        <div className="header-right">
          <button onClick={toggleLanguage} className="lang-btn">
            {lang === "tr" ? "EN" : "TR"}
          </button>
          <a
            href="https://www.medicana.com.tr/online-randevu?d=6g8OSll_QHs=&h=eJTRa8B9u7U=&b=O9z2njYFPJY="
            target="_blank"
            rel="noopener noreferrer"
            className="appointment-btn"
          >
            {content[lang].appointment}
          </a>
        </div>
      </header>
      <h1 className="page-title">{content[lang].opinion}</h1>
      <div className="opinions-section">
        <div
          className="opinions-carousel-container"
          onMouseEnter={stopSlider}
          onMouseLeave={startSlider}
        >
          <div
            className="opinions-carousel"
            style={{ transform: `translateX(-${index * 340}px)` }}
          >
            {opinions.map((text, i) => (
              <div key={i} className="opinion-box">
                <div className="opinion-text">{text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="reference-links">
        <a
          href="https://www.doktorsitesi.com/dr-ogr-uyesi-emre-cenesiz/cocuk-sagligi-ve-hastaliklari/istanbul"
          target="_blank"
          rel="noopener noreferrer"
        >
          Doktor Sitesi
        </a>
        <a
          href="https://bulutklinik.com/dr-ogr-uyesi-emre-cenesiz"
          target="_blank"
          rel="noopener noreferrer"
        >
          BulutKlinik
        </a>
      </div>
    </>
  );
}
